import React from "react";
import BtnDark from "@components/BtnDark";
import { useIntl } from "gatsby-plugin-intl";

const DownloadButton = () => {
  const { formatMessage, locale } = useIntl();

  const handleClick = () => {
    const a = document.createElement("a");
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.href =
      locale === "zh-Hans"
        ? process.env.REACT_APP_Taptap_URL
        : process.env.REACT_APP_APP_ADJUST_URL;
    a.click();
  };

  return <BtnDark onClick={handleClick}>{formatMessage({ id: "nav-download" })}</BtnDark>;
};

export default DownloadButton;
